exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".navbar {\n  position: fixed;\n  z-index: 1;\n  width: 100%;\n  background: #ffffff;\n  transition: all 200ms linear; }\n  .navbar .mat-button {\n    background: transparent !important;\n    color: #2858a0; }\n    .navbar .mat-button:not(.logo) {\n      border-radius: 19px !important; }\n    .navbar .mat-button.active {\n      color: #ff716e !important;\n      font-weight: bold; }\n    .navbar .mat-button.logo {\n      max-width: 250px; }\n      .navbar .mat-button.logo img {\n        width: 100%; }\n  .navbar:not(.top) {\n    color: #2858a0;\n    box-shadow: 0px 7px 9px rgba(0, 0, 0, 0.2); }\n  .navbar.top {\n    background: rgba(32, 40, 57, 0.3);\n    color: #ffffff; }\n    .navbar.top .mat-button {\n      background: transparent;\n      color: #ffffff; }\n      .navbar.top .mat-button:hover {\n        background: rgba(255, 255, 255, 0.6); }\n      .navbar.top .mat-button.logo:hover {\n        background: transparent; }\n\n.mat-menu-item {\n  color: #2858a0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/navbar/navbar.component.scss
// module id = 289
// module chunks = 1